import { Injectable, Injector } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ServiceLocator {
  static injector: Injector;

  constructor(private inject: Injector) {
    ServiceLocator.injector = inject;
  }
}
